import { getStoredAttribution } from '../../analytics/attribution';

// tendera.fi pricing "Valitse Seuranta / Pro / Intelligence" sends ?target_plan=<slug> to /register.
// Slug -> the plan's canonical backend `name`.
const TARGET_PLAN_NAMES = {
    monitoring: 'Monitoring',
    pro: 'Pro',
    intelligence: 'Intelligence',
};

const OFFER_SHOWN_PREFIX = 'tendera:target-plan-offer-shown:';

export const normalizeTargetPlan = (value) => {
    const slug = typeof value === 'string' ? value.trim().toLowerCase() : '';
    return TARGET_PLAN_NAMES[slug] ? slug : null;
};

export const getTargetPlanName = (targetPlan) => TARGET_PLAN_NAMES[normalizeTargetPlan(targetPlan)] || null;

// Same latest-touch-first pick as trackEvent's attribution context.
export const getAttributedTargetPlan = () => {
    const { first_touch: firstTouch, latest_touch: latestTouch } = getStoredAttribution();
    return normalizeTargetPlan(latestTouch?.target_plan || firstTouch?.target_plan);
};

export const hasTargetPlanOfferBeenShown = (userId) => {
    if (!userId) return true;
    try {
        return window.localStorage.getItem(`${OFFER_SHOWN_PREFIX}${userId}`) === 'true';
    } catch {
        return true;
    }
};

export const markTargetPlanOfferShown = (userId) => {
    if (!userId) return;
    try {
        window.localStorage.setItem(`${OFFER_SHOWN_PREFIX}${userId}`, 'true');
    } catch {
        // Best-effort: without storage the offer may show again on a later onboarding landing.
    }
};
